<template>
  <div>
    <slot name="label">
      <template v-if="label">
        <label>{{label}}</label>
        <br>
      </template>
    </slot>
    <el-select class="select-default max-step-width job-boards-select"
               :value="value"
               :loading="loading"
               @change="onChange"
               :placeholder="$t('generic.select')"
               v-bind="$attrs">
      <el-option v-for="product in products"
                 class="select-default"
                 :key="product.id"
                 :label="product.job_board.name"
                 :value="optionKey ? product[optionKey]: product">
      </el-option>
    </el-select>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import JobBoardService from 'src/services/JobBoardService'

  export default {
    name: 'job-boards-for-product-autocomplete',
    inheritAttrs: false,
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      value: {
        type: [String, Number, Array, Object],
        default: () => null
      },
      label: {
        type: String
      },
      productId: {
        type: [Number, String],
        default: ''
      },
      optionKey: {
        type: String,
        default: 'job_board_id'
      },
      arrayOnly: {
        type: Boolean,
        default: false
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    data () {
      return {
        loading: false,
        products: []
      }
    },
    methods: {
      onChange (val) {
        this.$emit('change', val)
      },
      async getJobBoards (productId) {
        try {
          this.loading = true
          let { data } = await JobBoardService.getJobBoardsForProduct(productId)
          this.products = data
          if (this.products && this.products.length === 1) {
            let product = this.products[0]
            let val = this.optionKey ? product[this.optionKey]: product
            if (this.arrayOnly) {
              this.onChange([val])
            } else {
              this.onChange(val)
            }
          }
        } finally {
          this.loading = false
        }
      }
    },
    watch: {
      productId: {
        immediate: true,
        handler: function (newVal)  {
          if (newVal) {
            this.getJobBoards(newVal)
          }
        }
      }
    }
  }
</script>
<style lang="scss">
  .job-boards-select {
    &.max-step-width {
      width: 100%;
      max-width: 100%;
    }
  }
</style>
